import React from 'react';
import { Trash2, MoreVertical, Pencil } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Left-hand list of barbers with per-row kebab menu (Edit / Remove).
export const BarberList = ({
  barbers, selectedBarber, setSelectedBarber,
  shopAdminUids, menuOpenId, setMenuOpenId,
  openEditForm, handleDeleteBarber, deletingBarberId,
}) => (
  <div className="panel barber-list">
    {barbers.map(barber => (
      <div
        key={barber.id}
        className={`bcard ${selectedBarber?.id === barber.id ? 'on' : ''} ${menuOpenId === barber.id ? 'menu-open' : ''}`}
        onClick={() => setSelectedBarber(barber)}
      >
        {barber.avatar_url ? (
          <img
            className="circ circ-img"
            src={`${BACKEND_URL}/api/barbers/${barber.id}/avatar`}
            alt={barber.name}
            data-testid={`barber-list-avatar-${barber.id}`}
          />
        ) : (
          <span className="circ">{barber.name.charAt(0)}</span>
        )}
        <div className="bi">
          <b>
            <span className="bn">{barber.name}</span>
            {barber.user_id && shopAdminUids.has(barber.user_id) && (
              <span className="adm-pill" data-testid={`barber-shopadmin-${barber.id}`}>Shop Admin</span>
            )}
          </b>
          <small>{[barber.role, barber.bio].filter(Boolean).join(' · ')}</small>
        </div>
        <div className="bcard-menu-root" onClick={(e) => e.stopPropagation()}>
          <button
            type="button"
            className="bcard-menu-btn"
            onClick={() => setMenuOpenId(prev => prev === barber.id ? null : barber.id)}
            aria-haspopup="menu"
            aria-expanded={menuOpenId === barber.id}
            aria-label={`Actions for ${barber.name}`}
            title="Actions"
            data-testid={`barber-actions-${barber.id}`}
          >
            <MoreVertical size={16} />
          </button>
          {menuOpenId === barber.id && (
            <div className="bcard-menu" role="menu" data-testid={`barber-menu-${barber.id}`}>
              <button
                type="button"
                role="menuitem"
                className="bcard-menu-item"
                onClick={() => { setMenuOpenId(null); openEditForm(barber); }}
                data-testid={`barber-edit-${barber.id}`}
              >
                <Pencil size={13} /> Edit
              </button>
              <button
                type="button"
                role="menuitem"
                className="bcard-menu-item danger"
                onClick={() => { setMenuOpenId(null); handleDeleteBarber(barber); }}
                disabled={deletingBarberId === barber.id}
                data-testid={`barber-delete-${barber.id}`}
              >
                <Trash2 size={13} /> Remove
              </button>
            </div>
          )}
        </div>
      </div>
    ))}
    {barbers.length === 0 && (
      <div className="empty-state">
        <p>No barbers yet. Add your first barber.</p>
      </div>
    )}
  </div>
);
